import { DeleteOutlined } from '@ant-design/icons';
import { App, Popconfirm } from 'antd';
import { memo, useCallback, useEffect } from 'react';

import { credentialsActions } from '@store/credentials/credentials.slice';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { useMutation } from '@hook/common/use-mutation.hook';
import { useDeleteCredentialMutation } from '@hook/credential/credential.hooks';

interface DeleteCredentialProps {
  id: string;
  isTablet: boolean;
}

export const DeleteCredential = memo(({ id, isTablet }: DeleteCredentialProps) => {
  const { action, state } = useMutation(useDeleteCredentialMutation(), credentialsActions, credentialsActions.setData);
  const { message } = App.useApp();

  const handleDelete = useCallback(() => action(id), [id, action]);

  useEffect(
    () => void (state.isSuccess && message.success('Credentials was successfully deleted')),
    [state.isSuccess, message],
  );

  return (
    <Popconfirm
      cancelText='No'
      description='Are you sure to delete this credential?'
      okText='Yes'
      placement='left'
      title='Delete the credential'
      onConfirm={handleDelete}
    >
      <Button icon={<DeleteOutlined />} size={isTablet ? 'middle' : 'small'} type={ButtonTypeEnum.Error}>
        {isTablet ? null : 'Remove'}
      </Button>
    </Popconfirm>
  );
});
